import React from "react";

const BeheardLogo = ({ size, color = "#e07373" }) => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 491.03 70.85"
            height={size}
        >
            <path
                d="M0,2.85A1.87,1.87,0,0,1,1.87,1H24.4C36.11,1,45.17,8.86,45.17,19.19c0,7.58-6.2,13.48-10.83,15.64,5.22,1.68,12.8,7,12.8,16,0,11-9.45,19-21.46,19H1.87A1.87,1.87,0,0,1,0,68ZM23.22,29.91c5,0,8.47-3.93,8.47-8.85a8,8,0,0,0-8.47-8.37H12.69V29.91ZM24.6,58.26a8.79,8.79,0,0,0,8.86-9c0-4.92-4.92-8.56-10-8.56H12.69V58.26Z"
                style={{ fill: color }}
            />
            <path
                d="M60.71,2.85A1.87,1.87,0,0,1,62.58,1h40.05a1.87,1.87,0,0,1,1.87,1.87v8.07a1.86,1.86,0,0,1-1.87,1.87H73.51V28.93h24.3a1.93,1.93,0,0,1,1.87,1.87V39a1.87,1.87,0,0,1-1.87,1.87H73.51V58.06h29.12a1.86,1.86,0,0,1,1.87,1.87V68a1.87,1.87,0,0,1-1.87,1.87h-40A1.87,1.87,0,0,1,60.71,68Z"
                style={{ fill: color }}
            />
            <path
                d="M140.32,2.85A1.94,1.94,0,0,1,142.19,1h9.15a1.87,1.87,0,0,1,1.87,1.87V28.93h32.08V2.85A1.87,1.87,0,0,1,187.16,1h9.06a1.94,1.94,0,0,1,1.87,1.87V68a1.94,1.94,0,0,1-1.87,1.87h-9.06A1.87,1.87,0,0,1,185.29,68V40.84H153.21V68a1.87,1.87,0,0,1-1.87,1.87h-9.15A1.94,1.94,0,0,1,140.32,68Z"
                style={{ fill: color }}
            />
            <path
                d="M216,2.85A1.86,1.86,0,0,1,217.86,1h40.06a1.86,1.86,0,0,1,1.86,1.87v8.07a1.86,1.86,0,0,1-1.86,1.87H228.79V28.93h24.3A1.93,1.93,0,0,1,255,30.8V39a1.87,1.87,0,0,1-1.87,1.87h-24.3V58.06h29.13a1.86,1.86,0,0,1,1.86,1.87V68a1.86,1.86,0,0,1-1.86,1.87H217.86A1.86,1.86,0,0,1,216,68Z"
                style={{ fill: color }}
            />
            <path
                d="M264.9,67.31,295.51,1.08A1.75,1.75,0,0,1,297.18,0h1a1.68,1.68,0,0,1,1.68,1.08l30.3,66.23a1.74,1.74,0,0,1-1.67,2.56h-8.56c-1.48,0-2.17-.59-2.85-2l-4.83-10.63H282.81L278,67.9a3,3,0,0,1-2.85,2h-8.57A1.74,1.74,0,0,1,264.9,67.31Zm42.51-21L297.57,24.7h-.29l-9.65,21.65Z"
                style={{ fill: color }}
            />
            <path
                d="M339.1,2.85A1.87,1.87,0,0,1,341,1h28.14a21.31,21.31,0,0,1,21.45,21.16c0,9.05-6,16.43-14.56,19.88l13.48,25a1.87,1.87,0,0,1-1.67,2.86H377.48A1.7,1.7,0,0,1,375.9,69L362.81,42.9H351.89V68A1.93,1.93,0,0,1,350,69.87h-9A1.87,1.87,0,0,1,339.1,68ZM368,32.38a10,10,0,0,0,9.74-10A9.79,9.79,0,0,0,368,12.79H352V32.38Z"
                style={{ fill: color }}
            />
            <path
                d="M404.64,2.85A1.85,1.85,0,0,1,406.41,1h23.32a34.45,34.45,0,1,1,0,68.89H406.41A1.85,1.85,0,0,1,404.64,68Zm23.91,55c12.79,0,22.14-9.64,22.14-22.53s-9.35-22.44-22.14-22.44H417.33v45Z"
                style={{ fill: color }}
            />
            <path
                d="M482.87,54.61A8.21,8.21,0,0,1,491,62.78a8.07,8.07,0,1,1-8.16-8.17Zm-3.35-13.08-3.84-27.46V2.85A1.94,1.94,0,0,1,477.55,1h10.83a1.94,1.94,0,0,1,1.87,1.87v11l-3.84,27.65a2,2,0,0,1-1.87,1.57h-3.15A2,2,0,0,1,479.52,41.53Z"
                style={{ fill: color }}
            />
        </svg>
    );
};

export default BeheardLogo;
